package org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.update_checkout


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class UpdateUserCheckoutModel(
    @SerialName("data")
    val `data`: Data,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)